import axios from "axios";

const url = process.env.REACT_APP_API_URL;

export const post = (data) => axios.post(url + `/api/organizations`, data);
export const get = (id = null) => axios.get(url + `/api/organizations${(id !== null ? '/' + id : '')}`);
export const plans = (group) => axios.get(url + '/api/plans?group=' + group);
